export default "__VITE_ASSET__JQbElIiE__"